import Typography from 'components/atoms/Typography';
import Toggle from 'components/molecules/Toggle';
import { MediaUploadResult, CloudinaryMediaUploader } from 'components/organisms/CloudinaryMediaUploader';
import { VideoTemplateConfig as VideoTemplateConfigType } from 'utils/gloo-types';

interface VideoTemplateConfigProps {
  template?: any;
  handleChange: (data: any) => void;
  handleForm: (data: any) => void;
}
function VideoTemplateConfig({ template, handleChange, handleForm }: VideoTemplateConfigProps) {
  const templateConfig = template.config as VideoTemplateConfigType;

  const updateConfigProperty = (key: keyof VideoTemplateConfigType, value) => {
    const changeFn = (prevState) => ({ ...prevState, config: { ...prevState.config, [key]: value } });

    handleChange(changeFn);
    handleForm(changeFn);
  };

  const handleMediaUpload = (mediaUploadResult: MediaUploadResult) => {
    updateConfigProperty('url', mediaUploadResult.info.playback_url);
    updateConfigProperty('downloadUrl', mediaUploadResult.info.url);
  };

  const videoMaxSize = { size: 4 * 1000 * 1024 * 1024, label: '4 GB' };
  return (
    <>
      <div className="flex flex-col items-start mb-4">
        <Typography variant="sm" className="mb-4">
          Some things to keep in mind when uploading a video:
          <ul className="list-disc list-inside">
            <li>
              Make sure your video is less than <strong>{videoMaxSize.label}</strong>.
            </li>
            <li>A 16:9 video aspect ratio is preferred</li>
          </ul>
        </Typography>
        <CloudinaryMediaUploader
          buttonType="button"
          text={templateConfig?.url ? 'Choose a different video' : 'Choose Video to Upload'}
          helpText="Upload Video"
          type="primary"
          icon="video"
          iconSize={20}
          onMediaUpload={handleMediaUpload}
          uploaderOptions={{
            clientAllowedFormats: ['video'],
            maxFileSize: videoMaxSize.size,
            resourceType: 'video',
          }}
        />

        <Typography variant="base" className="mt-2">
          Streaming Url: {templateConfig?.url}
        </Typography>
        {templateConfig?.downloadUrl && (
          <Typography variant="base" className="mt-2">
            Download Url: {templateConfig?.downloadUrl}
          </Typography>
        )}
        <Typography variant="sm" className="mt-1">
          You can view a preview of this video on the right in the Drawer Header Preview.
        </Typography>
      </div>

      <Toggle
        label="User Can Download?"
        onChange={(boolean: boolean) => {
          updateConfigProperty('canDownload', boolean);
        }}
        defaultOn={templateConfig?.canDownload}
      />
    </>
  );
}

export default VideoTemplateConfig;
